import * as React from 'react'
import {
  Pressable,
  PressableProps,
  View,
  StyleSheet,
  GestureResponderEvent,
} from 'react-native'
import { FontAwesomeIcon, findIconDefinition } from '@purposity/icons'
import { white, abbyGray, primary } from '@themes/Colors'
import { defaultShadow } from '@themes/Shadows'

export type NeedCardTypes = 'metByCurrentUser' | 'met' | undefined
type OtherCardTypes = 'profile' | 'story' | 'general' | 'default'
type CardType = NeedCardTypes | OtherCardTypes

type CardProps = PressableProps & {
  type?: CardType
  disabled?: boolean
  children?: React.ReactNode
}

export function Card({
  type = 'default',
  disabled = false,
  children,
  ...props
}: CardProps) {
  const showCheck = type === 'met' || type === 'metByCurrentUser'

  const handlePress = (event: GestureResponderEvent) => {
    if (props.onPress) props.onPress(event)
  }

  const renderCard = React.useMemo(() => {
    const containerStyles = {
      metByCurrentUser: styles.metContainer,
      profile: styles.profileContainer,
      met: styles.metContainer,
      story: styles.storyContainer,
      general: styles.generalContainer,
      default: styles.container,
    }
    return (
      <View style={[styles.baseContainer, containerStyles[type]]}>
        {showCheck && (
          <View style={styles.metCheck}>
            <FontAwesomeIcon
              icon={findIconDefinition({
                prefix: 'fas',
                iconName: 'check-circle',
              })}
              style={styles.metCheckIcon}
              fixedWidth
            />
          </View>
        )}
        <View style={type === 'met' ? styles.overlay : null}>{children}</View>
      </View>
    )
  }, [children, showCheck, type])

  if (props.onPress)
    return (
      <Pressable
        disabled={disabled}
        onPress={handlePress}
        style={styles.pressableWrapper}
        {...props}
      >
        {renderCard}
      </Pressable>
    )

  return <>{renderCard}</>
}

const styles = StyleSheet.create({
  pressableWrapper: {
    flex: 1,
  },
  baseContainer: {
    userSelect: 'none',
    backgroundColor: white,
    borderRadius: 8,
    flex: 1,
    width: '100%',
  },
  container: {
    ...defaultShadow,
    paddingVertical: 8,
    paddingHorizontal: 16,
  },
  storyContainer: {
    ...defaultShadow,
  },
  overlay: {
    opacity: 0.5,
    backgroundColor: abbyGray,
    flex: 1,
  },
  metContainer: {
    color: primary,
    position: 'relative',

    paddingVertical: 10,
    paddingHorizontal: 15,
    borderColor: primary,
    borderWidth: 1,
  },
  profileContainer: {
    backgroundColor: primary,
    ...defaultShadow,
    paddingVertical: 10,
    paddingHorizontal: 15,
  },
  generalContainer: {
    ...defaultShadow,
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  metCheck: {
    width: 18,
    height: 18,
    position: 'absolute',
    top: -7,
    left: 13,
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',

    backgroundColor: '#ffffff',
  },
  metCheckIcon: {
    backgroundColor: '#ffffff',
  },
})
